export default __webpack_public_path__ + "static/media/imtiaz.eb174387.png";